import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthProvider';
import { loginItemsSelector, setUserDetails, setUserDetailsError, setUserDetailsLoading } from '../../redux/slices/login';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../Asset/image/tamara_logo.png';
import GoogleLoginButton from '../../Asset/image/google.png';
import verificationImage from '../../Asset/image/VerificationImg.png';
import { loginUser } from '../../services/loginService';
import { Button, Col, Container, Form, FormLabel, Image, InputGroup, Row } from 'react-bootstrap';
import CustomImage from '../../CommonComponents/CustomImage';
import OtpInputBox from '../../CommonComponents/OtpInputBox';
import { otpVerifyService, resendOtpService } from '../../services/userService';
import { toast } from 'react-toastify';
import { errorMessage } from '../../lib/helper';


const Verification = () => {
    /* @ts-ignore */
    const { user, login } = useAuth();
    const [validated, setValidated] = useState(false);
    const [otp, setOtp] = useState('');
    const [counter, setCounter] = useState(59);
    const [error, setError] = useState('');
    const allUserState = useSelector(loginItemsSelector);
    const location = useLocation();
    const emailUser = location?.state?.email;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            dispatch(setUserDetails(user))
            navigate('/app/user-dashboard', { replace: true });
        }
    }, [user]);

    const onChange = (value) => { setOtp(value.slice(0, 6)) }
    useEffect(() => {
        dispatch(setUserDetailsLoading(false));
        let myInterval = setInterval(() => {
            if (counter > 0) {
                setCounter(counter - 1);
            } else {
                clearInterval(myInterval);
                // resendOtp();
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    }, [counter]);

    const verificationOtp = async () => {
        if (otp.length !== 6) {
            setError("Enter 6 digit OTP");
            return;
        }
        try {
            const params = {
                "email": emailUser,
                "otp": otp,
            };
            const response = await otpVerifyService(params);
            if (response?.data) {
                toast.success(response?.data);
                dispatch(setUserDetailsLoading(false));
                navigate('/app/login')
            } else {
                setCounter(60);
                toast.error("Something went wrong");
                dispatch(setUserDetailsLoading(false));
            }
        } catch (e) {
            dispatch(
                setUserDetailsError({
                    isError: true,
                    message: errorMessage(e),
                }),
            );
            dispatch(setUserDetailsLoading(false));
            toast.error(errorMessage(e), {
                autoClose: 2500,
            });
            return false
        }
    };

    const resendOtp = async () => {
        try {
            const params = {
                "email": emailUser,
            };
            const response = await resendOtpService(params);
            toast.success(response?.data);
            setCounter(59);
        } catch (err) {
            console.log('resendOtp err', err);
        }
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            setValidated(false);
        } else {
            if (otp !== '') {
                dispatch(setUserDetailsLoading(true));
                verificationOtp()
            }
            else
                toast.error("Please enter otp")
        }
        setValidated(true);
    };

    return (
        <>
            <div className="main-login-page" style={{ backgroundColor: " #060B19" }}>
                <Container fluid className="login-div">
                    <div className="login-container">
                        <CustomImage className="logo_style" src={Logo} />
                        <h2 className="App-header">Verification</h2>
                        <p className="sub-header">Welcome! Please verify your account.</p>


                        <Form noValidate validated={validated} onSubmit={handleSubmit} >
                            <Row className='d-flex justify-content-center'>
                                <p className='create-link d-flex justify-content-center'>{emailUser}</p>
                                {/* <p className='text-label d-flex justify-content-center'>00:{(counter < 10) ? `0${counter}` : counter}</p> */}
                                <p className='text-label d-flex justify-content-center mt-4'>{`OTP is sent to this email.`}</p>
                                <p className='text-label d-flex justify-content-center'>{`Please Fill OTP.`}</p>
                                <div className='mt-4 d-flex justify-content-center'>
                                    <OtpInputBox value={otp} valueLength={6} onChange={onChange} />
                                </div>


                                <Button type='submit' className='login_button mt-4' disabled={allUserState?.user?.loading}>
                                    {allUserState?.user?.loading ? (
                                        <div className='d-flex justify-content-center'>
                                            <center>
                                                <div
                                                    style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                                    class="spinner-border me-2 "
                                                    role="status"
                                                />
                                            </center>Submit
                                        </div>) : "Submit"}
                                </Button>
                            </Row>
                            <div className="d-flex justify-content-center mt-4">
                                <p className='text-label'>Back to &nbsp;
                                    <Link to="/" className="create-link pe-4">Log In</Link></p>
                            </div>

                        </Form>
                    </div>
                    <div className="d-none d-lg-block" style={{
                        position: "absolute",
                        zIndex: 0,
                        height: '100vh',
                        width: '55vw',
                        right: 30
                    }}>
                        <CustomImage className="w-100" src={verificationImage} />
                    </div>
                </Container>
            </div >
        </>
    );
};

export default Verification;
